.root {
  --lockup-padding: var(--space-2);
  --lockup-gap: var(--space-2);

  border: 1px solid var(--color-border-primary);
  border-radius: var(--radius-3);
  transition: background-color 200ms;

  &:has(.accountLink:hover) {
    background-color: var(--color-bg-highlight);
  }

  &:has(.accountLink:focus-visible) {
    outline: var(--outline-focus-default);
    background-color: var(--color-bg-highlight);
  }
}

.accountLink {
  // Disable default hover & focus styles
  &:hover {
    text-decoration: none !important;
  }

  &:focus-visible {
    outline: none;
  }
}

.dotsIcon {
  padding: var(--space-2);
}

.profileMenuItem {
  --lockup-padding: 0;
  --lockup-gap: var(--space-2);

  color: inherit;
}
